import { css, cx } from "styled-system/css";
import { cf } from "@/components/brand/sfturnos-styles";

export function DashboardEmpty({ title, hint }: { title: string; hint?: string }) {
  return (
    <div
      className={cx(
        cf.dashSurface,
        css({
          py: "12",
          px: "6",
          textAlign: "center",
          maxW: "md",
          mx: "auto",
        }),
      )}
    >
      <p className={css({ fontWeight: "semibold", color: "#0f172a", mb: hint ? "2" : "0" })}>{title}</p>
      {hint ? <p className={css({ fontSize: "sm", color: "#64748b", lineHeight: "1.5" })}>{hint}</p> : null}
    </div>
  );
}
